import { gql } from '@apollo/client'

const allUserQuery = gql`
  query allUser($filter: JSON!, $options: JSON) {
    allUser(filter: $filter, options: $options) {
      _id
      profile {
        _id
        name
        email
        picture
      }
      status
      company {
        _id
        name
        domain
      }
    }
  }
`

export const useCollaborators = () => {
  const dataLoadOptions = ({ filter }: any) => ({
    query: allUserQuery,
    filter: ({ input }: any) => {
      const result = {
        status: 'active',
        $or: [
          { 'profile.name': { $regex: input, $options: 'i' } },
          {
            'profile.email': {
              $regex: input,
              $options: 'i',
            },
          },
          {
            'company.name': {
              $regex: input,
              $options: 'i',
            },
          },
        ],
        ...filter,
      }

      return result
    },
    options: () => ({
      sort: { 'company.name': 1 as const },
    }),
    resultFieldName: 'allUser',
  })

  return { dataLoadOptions }
}
